import { Field, SectionSelectFieldProps } from "@/features/FilterTable/types";

type BaseParams = {
  assetClassFieldName: string;
  assetSubclassFieldName: string;
  assetClassLabel: string;
  assetSubclassLabel: string;
  client: string;
  staticDataTableName: string;
  language: string;
  assetClassTranslateKey?: string;
  assetSubclassTranslateKey?: string;
};

type SectionSubclassParams = BaseParams & {
  assetSubclassFieldType?: "sectionSelect";
  assetSubclassOptions: SectionSelectFieldProps["options"];
  sectionNameTranslationKey?: string;
  sectionNameTableName?: string;
};

type SelectSubclassParams = BaseParams & {
  assetSubclassFieldType: "select";
};

type AssetClassFilterFieldParams =
  | SectionSubclassParams
  | SelectSubclassParams;

export function createAssetClassFilterFields(
  params: AssetClassFilterFieldParams,
): Field[] {
  const assetClassTranslateKey = params.assetClassTranslateKey ?? "asset_class_1";
  const assetSubclassTranslateKey =
    params.assetSubclassTranslateKey ?? "asset_class_2";

  const assetClassField: Field = {
    name: params.assetClassFieldName,
    label: params.assetClassLabel,
    type: "select",
    useTranslation: true,
    client: params.client,
    table_name: params.staticDataTableName,
    language: params.language,
    translate_key: assetClassTranslateKey,
  };

  if (params.assetSubclassFieldType === "select") {
    return [
      assetClassField,
      {
        name: params.assetSubclassFieldName,
        label: params.assetSubclassLabel,
        type: "select",
        useTranslation: true,
        client: params.client,
        table_name: params.staticDataTableName,
        language: params.language,
        translate_key: assetSubclassTranslateKey,
      },
    ];
  }

  return [
    assetClassField,
    {
      name: params.assetSubclassFieldName,
      label: params.assetSubclassLabel,
      type: "sectionSelect",
      useTranslation: true,
      useTransactionForSectionName: true,
      section_name_translation_key:
        params.sectionNameTranslationKey ?? assetClassTranslateKey,
      section_name_table_name:
        params.sectionNameTableName ?? params.staticDataTableName,
      client: params.client,
      table_name: params.staticDataTableName,
      language: params.language,
      translate_key: assetSubclassTranslateKey,
      options: params.assetSubclassOptions,
    },
  ];
}
